module.exports = __webpack_public_path__ + "img/inactive-6.280d8fe4.svg";